module.exports = __webpack_public_path__ + "static/media/question4.f0c2bb02.gif";